import { inject, Injectable } from '@angular/core'
import { Action, select, Store } from '@ngrx/store'
import { PaddleNumbersState } from './base-paddle-numbers.reducer'
import * as PaddleNumbersSelectors from './base-paddle-numbers.selectors'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'

@Injectable({
  providedIn: 'root',
})
export class BasePaddleNumbersFacade implements GbBaseFacade {
  private readonly store = inject(Store<PaddleNumbersState>)

  paddleNumberLoaded$ = this.store.pipe(select(PaddleNumbersSelectors.selectPaddleNumberLoaded))

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
